// extracted by mini-css-extract-plugin
var _1 = "NoticeStyle-module__notice___QfHQf";
var _2 = "NoticeStyle-module__notice-gray___f8r76";
var _3 = "NoticeStyle-module__notice-green___SlIfe";
var _4 = "NoticeStyle-module__notice-no-divider___CEP8I";
var _5 = "NoticeStyle-module__notice-orange___lEhLN";
var _6 = "NoticeStyle-module__notice-purple___AYWv9";
var _7 = "NoticeStyle-module__notice-gray___f8r76";
var _8 = "NoticeStyle-module__notice-green___SlIfe";
var _9 = "NoticeStyle-module__notice-no-divider___CEP8I";
var _a = "NoticeStyle-module__notice-orange___lEhLN";
var _b = "NoticeStyle-module__notice-purple___AYWv9";
export { _1 as "notice", _2 as "notice-gray", _3 as "notice-green", _4 as "notice-no-divider", _5 as "notice-orange", _6 as "notice-purple", _7 as "noticeGray", _8 as "noticeGreen", _9 as "noticeNoDivider", _a as "noticeOrange", _b as "noticePurple" }
